var React = require('react');

function SPageDownHud18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","d":"M9,15.48045 C9.54795,15.47175 9.9822,15.0309 10,14.48045 L10,5.8789 L13.02875,8.6969 C13.42035,9.0377 14.01665,9.07155 14.3919,8.704 C14.76725,8.33645 14.75115,7.7379 14.3879,7.36585 L9.6228,3.13475 C9.203125,2.79395 8.734375,2.79395 8.34375,3.13475 C8.08333333,3.36195 6.50571667,4.77663333 3.6109,7.3788 C3.2476,7.75085 3.23155,8.34935 3.60685,8.7169 C3.9822,9.08445 4.57845,9.05065 4.97005,8.70985 L8,5.8789 L8,14.48045 C8.01805,15.03615 8.45205,15.48915 9,15.48045 Z M8.99025,0 C13.95315,0.00585 17.9746,4.02735 17.98045,8.99025 C17.98045,13.9551 13.9551,17.98045 8.99025,17.98045 C4.0254,17.98045 0,13.9551 0,8.99025 C0,4.0254 4.0254,0 8.99025,0 Z","transform":"matrix(1 0 0 -1 0 17.98)"}));
}

SPageDownHud18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SPageDownHud18;

SPageDownHud18.default = SPageDownHud18;
